"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Init = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _FeatureFlags = require("../../services/FeatureFlags");
var _initUtils = require("./initUtils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Init = function Init() {
  var localPeerID = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var localPeerRole = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerRoleName);
  var localPeerName = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerName);
  var sessionId = (0, _reactSdk.useHMSStore)(_reactSdk.selectSessionId);
  var _useTheme = (0, _reactUi.useTheme)(),
    toggleTheme = _useTheme.toggleTheme;
  (0, _react.useEffect)(function () {
    window.toggleUiTheme = toggleTheme;
  }, [toggleTheme]);
  (0, _react.useEffect)(function () {
    function resetHeight() {
      // reset the body height to that of the inner browser
      document.body.style.height = "".concat(window.innerHeight, "px");
    }
    // reset the height whenever the window's resized
    window.addEventListener("resize", resetHeight);
    // called to initially set the height.
    resetHeight();
    return function () {
      window.removeEventListener("resize", resetHeight);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (localPeerID && localPeerRole && localPeerName) {
      (0, _initUtils.setUpLogRocket)({
        localPeer: {
          id: localPeerID,
          name: localPeerName,
          roleName: localPeerRole
        },
        sessionId: sessionId
      });
    }
    // eslint-disable-next-line
  }, [localPeerID, localPeerName, localPeerRole, sessionId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FeatureFlags.FeatureFlagsInit, {});
};
exports.Init = Init;